import React, { FC } from "react";

interface IPieChartCenterLabelProps {
  subTitle: string;
  total: number;
  viewBox?: { cx: number; cy: number };
}

const PieChartCenterLabel: FC<IPieChartCenterLabelProps> = ({
  subTitle,
  total,
  viewBox,
}) => {
  const { cx, cy } = viewBox ?? { cx: 0, cy: 0 };

  return (
    <>
      <text
        x={cx}
        y={cy - 5}
        fill="rgba(0, 0, 0, 0.87)"
        className="recharts-text recharts-label"
        textAnchor="middle"
        dominantBaseline="central"
      >
        <tspan alignmentBaseline="middle" fontSize="32px" fontFamily="Roboto">
          {total}
        </tspan>
      </text>
      <text
        x={cx}
        y={cy + 20}
        fill="rgba(0, 0, 0, 0.54)"
        className="recharts-text recharts-label"
        textAnchor="middle"
        dominantBaseline="central"
      >
        <tspan fontSize="16px" fontFamily="Roboto">
          {subTitle}
        </tspan>
      </text>
    </>
  );
};

export default React.memo(PieChartCenterLabel);
